
/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client.

/*
 * EXPORTS
 */
export default gql`
  mutation RestartServerMutation {
    RestartServer {
      details
      message
      status
      success
    }
  }
`
